import { Injectable } from '@angular/core';
import * as moment from 'moment';
export interface UserInfo {
  email: string;
  firstName: string;
  lastName: string;
  roleName: string;
  userName: string;
  entityName:string;
  roleId: string;
  userId: string;
  entityId: string;
  defaultPage: string;
  originEntityId: string;
}
@Injectable()
export class Globals {
  public static positionArrayLength: number = 230;
  public static skeletonArray = Array(10).fill(0); // number of column's of skeleton.
  public static skeletonRows = Array(15).fill(0); // number of rows's of skeleton.
  getUser() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    return user;
  }

  getUserId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = user.user_info?.userId;
    return res;
  }

  getCompanyId() {
    let user: any = localStorage.getItem('Auth-user');
    user = JSON.parse(user);
    let res = atob(user.user_info?.companyId);
    return res;
  }

  getUserInfo(): UserInfo | null {
    const userStr = localStorage.getItem('Auth-user');
    if (!userStr) return null;

    try {
      const user = JSON.parse(userStr);
      const info = user?.user_info || {};

      const safeDecode = (value: any): string => (value ? atob(value) : '');

      return {
        email: info.email || '',
        firstName: info.firstName || '',
        lastName: info.lastName || '',
        roleName: info.roleName || '',
        userName: info.userName || '',
        entityName:info.entityname || '',
        roleId: safeDecode(info.roleId),
        userId: safeDecode(info.userId),
        entityId: safeDecode(info.entityId),
        defaultPage: info.defaultPage ? safeDecode(info.defaultPage) : info.defaultPage || '',
        originEntityId: '',
      };
    } catch (e) {
      console.error('Error parsing Auth-user:', e);
      return null;
    }
  }

  getToken() {
    let token: any = localStorage.getItem('Auth_token');
    return token;
  }

  decryptValue(encryptValue: any): any {
    return atob(encryptValue);
  }
  encryptValue(decryptValue: any): any {
    return btoa(decryptValue);
  }

  /*
   * @category WEBSITE
   * @author Original Author <vsharaf@moba.de>
   * @copyright MOBA
   * @comment Check USer have the permission or not.
   * @date 17-09-2025
   */
  checkPermission(permissionName: string, routeName: string): boolean {
    routeName = routeName.replace('/', '');
    const normalizedUrl = routeName.split('?')[0];
    const ignorePatterns = [
      /^hardware-details\/[A-Za-z0-9%+=/]+$/,
      /^product-details\/[A-Za-z0-9%+=/]+$/,
      /^profile$/,
    ];
    if (ignorePatterns.some((pattern) => pattern.test(normalizedUrl))) {
      return true;
    }
    const sideBar: any = localStorage.getItem('accessPage');
    const sidebarItems = JSON.parse(sideBar);
    for (let sideItem of sidebarItems) {
      if (
        routeName &&
        (sideItem.controller === routeName ||
          sideItem.SubMenu.some((subItem: any) => subItem.controller === routeName))
      ) {
        const permissions =
          sideItem.controller === routeName
            ? sideItem.permission
            : sideItem.SubMenu.find((subItem: any) => subItem.controller === routeName).permission;
        if (permissions.includes(permissionName)) {
          return true;
        }
      }
    }
    return false;
  }

  convertUTCToUserLocalTime(date: Date, format: string = ''): string {
    if (!date || date === 'NA' as any) {
      return 'NA';
    }

    var localTime = moment.utc(date).toDate();

    if (!localTime) {
      return 'NA';
    }
    // Create a new Date object with the UTC date's milliseconds
    const utcDate = new Date(localTime);

    // Get the dynamic time zone code of the user's browser
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Get the dynamic locale from the user's browser
    const userLocale = navigator.language;

    // Format the date as YYYY-MM-DD HH:mm:ss
    const year = utcDate.getFullYear();
    const month = (utcDate.getMonth() + 1 < 10 ? '0' : '') + (utcDate.getMonth() + 1);
    const day = (utcDate.getDate() < 10 ? '0' : '') + utcDate.getDate();
    const hours = (utcDate.getHours() < 10 ? '0' : '') + utcDate.getHours();
    const minutes = (utcDate.getMinutes() < 10 ? '0' : '') + utcDate.getMinutes();
    const seconds = (utcDate.getSeconds() < 10 ? '0' : '') + utcDate.getSeconds();

    // let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    let formattedDate: any = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    if (format == 'date') {
      formattedDate = `${year}-${month}-${day}`;
    }

    // If the format is 'milliseconds', return the timestamp
    if (format === 'milliseconds') {
      formattedDate = utcDate.getTime(); // Returns Unix timestamp in milliseconds
    }

    return formattedDate;
  }

  /** Convert URL image to Base64 (used in edit mode) */
  // convertImageUrlToBase64(url: string): Promise<string> {
  //   // Remove the domain part to let Angular proxy handle it
  //   const relativeUrl = url.replace('https://moba-download-area-api.azurewebsites.net', '');

  //   return fetch(relativeUrl)
  //     .then((res) => res.blob())
  //     .then(
  //       (blob) =>
  //         new Promise<string>((resolve) => {
  //           const reader = new FileReader();
  //           reader.onloadend = () => {
  //             const base64 = (reader.result as string).split(',')[1];
  //             resolve(base64);
  //           };
  //           reader.readAsDataURL(blob);
  //         })
  //     );
  // }

  async convertImageUrlToBase64(url: string): Promise<string> {
    try {
      const res = await fetch(url);

      if (!res.ok) {
        console.warn('Image not found:', url);
        return '';
      }

      const blob = await res.blob();
      return await this.blobToBase64(blob);
    } catch (e) {
      console.error('Failed to convert image:', e);
      return '';
    }
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
      reader.readAsDataURL(blob);
    });
  }

  extractFileNameFromUrl(url: string): string {
    try {
      // remove query params & fragments (if any)
      const cleanUrl = url.split('?')[0].split('#')[0];
      // extract file name after last slash
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    } catch {
      return '';
    }
  }

  getFileIcon(fileName: string, existingIcon?: string): string {
    if (existingIcon) return existingIcon;

    if (!fileName) return '/assets/images/default.jpg';

    const fileext = fileName.split('.').pop()?.toLowerCase() || '';

    const iconMap: Record<string, string> = {
      apk: '/assets/images/apk.png',
      bin: '/assets/images/bin.png',
      chm: '/assets/images/chm.png',
      exe: '/assets/images/exe.png',
      hpi: '/assets/images/hpi.png',
      mauc: '/assets/images/mauc.png',
      mp4: '/assets/images/mp4.png',
      pdf: '/assets/images/pdf.png',
      txt: '/assets/images/txt.png',
      url: '/assets/images/url.png',
      xltx: '/assets/images/xltx.png',
      zip: '/assets/images/zip.png',
      pptx: '/assets/images/pptx.png',
      pub: '/assets/images/pub.png',
    };

    return iconMap[fileext] || '/assets/images/default.png';
  }

  getFriendlyTypeName(name: string): string {
    if (!name) return '';
    const parts = name.split(':');
    if (parts.length === 2 && parts[0].trim().toLowerCase() === 'manual') {
      const [prefix, suffix] = parts;
      return `${suffix.trim()} ${prefix.trim()}`;
    }
    return name;
  }
}
